import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';

const HeaderOne = ({ id }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isScrolled, setIsScrolled] = useState(false);

    const openMenu = () => {
        setIsMenuOpen(true);
    };
    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        const handleScroll = () => {
            const scrolled = window.scrollY > 50;

            setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev));
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <header id={id} className="header-style-1">
                {/* <div className="header-topbar topbar-style-2">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-xl-8 col-lg-6 col-md-12">
                                <div className="header-contact text-center text-lg-start d-none d-sm-block">
                                    <ul className="list-inline">
                                        <li className="list-inline-item">
                                            <span className="me-2"><i className="fa fa-phone"></i></span><a href="tel:+62-812-3843-1234">+62-812-3843-1234</a>
                                        </li>

                                        <li className="list-inline-item">
                                            <span className="me-2"><i className="fa fa-envelope"></i></span><a href="mailto: englishteacher.niecindonesia@gmail.com">  englishteacher.niecindonesia@gmail.com</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="d-sm-flex justify-content-center justify-content-lg-end">
                                    <div className="header-socials text-center text-lg-end">
                                        <ul className="list-inline">
                                            <li className="list-inline-item"><Link to="https://www.facebook.com/profile.php?id=61553630410640" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></Link></li>
                                            <li className="list-inline-item"><Link to="https://x.com/NIEC_Indonesia/" target="_blank" rel="noopener noreferrer"><i className="ri-twitter-x-line"></i></Link></li>
                                            <li className="list-inline-item"><Link to="https://www.linkedin.com/company/niec-indonesia/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></Link></li>
                                            <li className="list-inline-item"><Link to="https://www.youtube.com/@niec_indonesia" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className={`header-navbar navbar-sticky ${windowWidth <= 991 ? 'mobile-menu' : ''} ${isScrolled ? 'navbar-scrolled' : 'navbar-transparent'}`} >
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="site-logo">
                                <a href="https://niecindonesia.com/" className="logo-wrapper">
                                    <img className='niec-logo logo-color' src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="niec-nav-logo-color" />
                                    <img className='niec-logo logo-white' src={`${process.env.PUBLIC_URL}/assets/images/logo-white.png`} alt="niec-nav-logo-white" />
                                </a>
                                <a href="https://niecindonesia.com/" className='logo-wrapper'>
                                    <img className='super-student-logo logo-color' src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`} alt="super-student-nav-logo-color" />
                                    <img className='super-student-logo logo-white' src={`${process.env.PUBLIC_URL}/assets/images/logo-ss-white.png`} alt="super-student-nav-logo-white" />
                                </a>
                            </div>

                            <div className="offcanvas-icon d-block d-lg-none">
                                <a onClick={openMenu} className="nav-toggler"><i className="fal fa-bars"></i></a>
                            </div>
                            <nav className={`site-navbar ms-auto ${isMenuOpen ? 'menu-on' : ''}`} >
                                <Nav onLinkClick={closeMenu} />
                                {isMenuOpen && (
                                    <a onClick={closeMenu} className="nav-close"><i className="fal fa-times"></i></a>
                                )}
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderOne;